import { useQuery } from "@tanstack/react-query";

import { useAppSelector } from "Hooks/useRedux";

import Api from "Api";

export default function useEvenets() {
  const { eventTypes, visible } = useAppSelector((state) => state.event);
  const { dataForPost } = useAppSelector((state) => state.star);
  const { date } = useAppSelector((state) => state.filters);

  const statusQuery = () => {
    return "status=enable";
  };
  const nameQuery = () => {
    return "type=car";
  };

  const evenData = {
    ScenarioUniqueId: "8219b30d-fbad-4e73-b9c1-36b01326461b",
    ServiceUniqueId: "a19dc9e2-6089-418d-ae78-081a6c401a48",
    IncludeNonServiceBranches: false,
    Parameters: {
      "2df513ed-7f09-11ef-8d00-1062eb32e4ff": eventTypes,
      "16071146-c0e7-402e-865c-b43c31ab65af": date.created_after || "2020-06-03",
      "525549e1-dd53-4136-9741-22279a462933": date.created_before || "2025-06-03",
    },
    InputTables: [],
    OutputColumns: [],
  };

  const { data, refetch, isLoading, isFetching } = useQuery({
    queryKey: [visible, eventTypes],
    queryFn: () => {
      return Api.sPost(
        "https://report2.ardban.ir:7072/https://report2.ardban.ir:8080/gateway/MSSE.DIA/api/ScenarioServiceCallApi/ShortTimeServiceExecute",
        evenData
      ).then((res) => {
        console.log(res.data.Rows, "nysthnyy");
        return res.data.Rows;
      });
    },
    enabled: visible,
  });

  return { data, isLoading, refetch, isFetching };
}
